<app-simple-grid
  [listOperator]="listRentalAgreementDriversOperator"
  [createOperator]="createRentalAgreementDriverOperator"
  [updateOperator]="updateRentalAgreementDriverOperator"
  [detailsOperator]="detailsRentalAgreementValueOperator"
  [deleteOperator]="deleteRentalAgreementDriverOperator"
  [baseActions]="baseRowActions()"
  [rowActionSelector]="rowActionSelector"
  [columnDefs]="columnDefs"
  (created)="driversChanged.emit()"
  (updated)="driversChanged.emit()"
  (deleted)="driversChanged.emit()" />
